import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { KioskFlowOperatorContext, KioskFlowPublishResult } from '../types/kiosk-flow-types';
import { assertOperator } from './flow-validation';

// Retries recording a publish whose push already reached the kiosks — the JSON is not pushed again
export class RecordKioskFlowVersionUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  async execute(ctx: KioskFlowOperatorContext, jsonSnapshot: string): Promise<KioskFlowPublishResult> {
    assertOperator(ctx);
    if (!jsonSnapshot?.trim()) {
      throw new Error('There is no published flow to record');
    }
    return this.repository.recordVersion(ctx, jsonSnapshot);
  }
}
